export default "__VITE_ASSET__BVZmFypy__"